// popup class
import { useContext, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import StateContext from '../stateContext';
import axios from 'axios';

export function Popup() {

  const { popup, setPopup, login, createNotification, userInfo, setUserInfo } = useContext(StateContext);
  const [productInfo, setProductInfo] = useState({});
  var renderedPopup = undefined;

  // get product info
  useEffect(() => {
    axios.defaults.xsrfCookieName = 'csrftoken';
    axios.defaults.xsrfHeaderName = "X-CSRFTOKEN";
    axios.defaults.withCredentials = true;

    axios.get("/api/subscription/products").then((response) => {
      if (response.status == 200) {
        setProductInfo(response.data.result);
      } else {
        createNotification({
          "status": "error",
          "msg": "Error fetching product info",
        })
      }
    })
  }, []);

  async function createCheckoutSession() {

    axios.defaults.xsrfCookieName = 'csrftoken';
    axios.defaults.xsrfHeaderName = "X-CSRFTOKEN";
    axios.defaults.withCredentials = true;

    axios.post("/api/subscription/checkout",
      {
        product_id: productInfo[0].id,
        email: userInfo.email,
        jwt: userInfo.jwt
      }
    ).then((response) => {
      if (response.status == 200 && response.data.results > 0 && response.data.success == true) {
        window.location.href = response.data.result;
      } else {
        createNotification({
          "status": "error",
          "msg": "Error generating subscription checkout",
        })
      }
    })
  }

  async function getSubscriptionManagementLink() {

    axios.defaults.xsrfCookieName = 'csrftoken';
    axios.defaults.xsrfHeaderName = "X-CSRFTOKEN";
    axios.defaults.withCredentials = true;

    axios.post("/api/subscription/manage",
      {
        email: userInfo.email,
        jwt: userInfo.jwt,
        return_url: window.location.href
      }
    ).then((response) => {
      if (response.status == 200 && response.data.results > 0 && response.data.success == true && response.data.results > 0) {
        window.location.href = response.data.result;
      } else {
        createNotification({
          "status": "error",
          "msg": "Error redirecting to subscription management",
        })
      }
    })
  }

  // get needed details for subscription details
  if (popup == undefined) {
    // do nothing
  } else if (popup.type == "login") {
    renderedPopup = (
      <div
        style={{
          backgroundColor: "#ffffff", width: "80%", minWidth: "300px", maxWidth: "350px", height: "fit-content",
          borderRadius: "10px", padding: "20px", position: "relative",
          display: "flex", flexDirection: "column", justifyContent: "center", 
          gap: "10px", alignItems: "center"
        }}
      >
        <button 
          type="button" 
          onClick={() => {setPopup(undefined)}}
          style={{
            position: 'absolute', right: "10px", top: "10px",
            backgroundColor: 'transparent', fontSize: "18px"
          }}
        >
          x
        </button>
        <h1 style={{ textAlign: "center"}}>{popup.msg}</h1>
        <button 
          className='next' style={{padding: "10px 20px"}}
          onClick={() => {window.location.href = "/login"}}
        >Login</button>
        <div style={{display: "flex", flexDirection: "row", justifyContent: "center", width: "100%"}}>
          <hr style={{width: "40%"}}/>
          <span>or</span>
          <hr style={{width: "40%"}}/>
        </div>
        <a href="/signup">Already have an account? <span>Signup</span></a>
      </div>
    )
  } else if (popup.type == "subscribe") {

    var previousSubscriber = ["unpaid", "canceled", "incomplete_expired", "past_due"].includes(userInfo.subscription_status);

    renderedPopup = (
      <div
        style={{
          backgroundColor: "#ffffff", width: "80%", minWidth: "300px", maxWidth: "350px", height: "fit-content",
          borderRadius: "10px", padding: "20px", position: "relative",
          display: "flex", flexDirection: "column", justifyContent: "center", 
          gap: "10px", alignItems: "center"
        }}
      >
        <button 
          type="button" 
          onClick={() => {setPopup(undefined)}}
          style={{
            position: 'absolute', right: "10px", top: "10px",
            backgroundColor: 'transparent', fontSize: "18px"
          }}
        >
          x
        </button>
        <h3>Work Guild Premium</h3>
        <h1 style={{ textAlign: "left"}}>{ previousSubscriber === true ? "Welcome back!" : "7 Day FREE trial" }</h1>
        <span style={{ textAlign: "center"}}>Generate Unlimited Resumes at the click of a button.</span>
        <div
          style={{
            display: "grid", position: "relative", width: "calc(100% - 20px)",
            gridTemplateColumns: "auto", gridTemplateRows: "1fr auto 1fr",
            gridTemplateAreas: `"timeframe" "price" "bill_note"`, gap: "10px",
            backgroundColor: "#f3f3fc", padding: "10px", borderRadius: "10px"
          }}
        >
          <h3 style={{gridArea: "timeframe", width: "100%"}}>Monthly</h3>
          <h2 style={{gridArea: "price", width: "100%"}}>${productInfo[0].price}</h2>
          <span style={{gridArea: "bill_note", width: "100%"}}>Billed Monthly</span>
          <span style={{
            fontSize: "12px", color: "white", backgroundColor: "#8066d5", 
            padding: "5px", borderRadius: "5px", position: "absolute",
            top: "10px", right: "10px"
          }}>{ previousSubscriber === true ? "START NOW" : "7-DAY FREE TRIAL" }</span>
        </div>
        <button 
          className='next' 
          style={{
            padding: "10px 20px", fontSize: "18px", display: 'flex', 
            flexDirection: "column", width: "100%"
          }}
          onClick={() => {if (previousSubscriber) { getSubscriptionManagementLink() } else {createCheckoutSession()}}}
        >
          { previousSubscriber === true ? 
          <>
          <span>Manage Subscription</span>
          
          </>
          :
          <>
            <span>START NOW</span>
            <span style={{fontSize: "12px", color: "#acb6f9"}}>NO PAYMENT REQUIRED TODAY</span>
          </>
          }
        </button>
      </div>
    )
  } else if (popup.type == "resume_gen_info_missing") {
    renderedPopup = (
      <div
        style={{
          backgroundColor: "#ffffff", width: "80%", minWidth: "300px", maxWidth: "350px", height: "fit-content",
          borderRadius: "10px", padding: "20px", position: "relative",
          display: "flex", flexDirection: "column", justifyContent: "center", 
          gap: "10px", alignItems: "center"
        }}
      >
        <button 
          type="button" 
          onClick={() => {setPopup(undefined)}}
          style={{
            position: 'absolute', right: "10px", top: "10px",
            backgroundColor: 'transparent', fontSize: "18px"
          }}
        >
          x
        </button>
        <h2>We need more information to a generate resume!</h2>
        {popup.missingInfo.map((item, index) => (
          <>
            { item == "user_details" ?<DetailCheck detailType="warning" msg="Missing user details!" navLink="/profile/userDetails"/> : undefined}
            { item == "skills" ?<DetailCheck detailType="warning" msg="Missing skills!" navLink="/profile/skills"/> : undefined}
            { item == "experiences" ?<DetailCheck detailType="warning" msg="Missing work experience!" navLink="/profile/workexperience"/> : undefined}
          </>
        ))}
      </div>
    )
  } else if (popup.type == "loading") {
    renderedPopup = (
      <div
        style={{
          backgroundColor: "#ffffff", width: "80%", minWidth: "300px", maxWidth: "350px", height: "fit-content",
          borderRadius: "10px", padding: "20px", position: "relative",
          display: "flex", flexDirection: "column", justifyContent: "center", 
          gap: "10px", alignItems: "center"
        }}
      >
        <h1 style={{ textAlign: "center"}}>{popup.msg}</h1>
        <h3 style={{ fontWeight: "normal"}}>One moment...</h3>
      </div>
    )
  }

  return (
    <section
      style={popup != undefined ? {
        position: "fixed", backgroundColor: "rgba(74, 75, 79, 0.8)", width: "100%", 
        height: "100%", zIndex: "4", top: "0px", left: "0px",
        display: 'flex', flexDirection: "column", alignItems: "center",
        justifyContent: "center"
      } : {display: "none"}}

      onClick={() => {setPopup(undefined)}}
    >
      {renderedPopup}    
    </section>
  )
}


export function DetailCheck({detailType, msg, navLink}) {

  return ( 
    <article
      style={
        detailType == "warning" ?
        { width: "calc(100% - 20px)", backgroundColor: '#fcedd8', border: "2px solid #FFA231",
        padding: "10px", borderRadius: "5px", position: "relative" }
        :
        { width: "calc(100% - 20px)", backgroundColor: '#edf6ee', border: "2px solid #62b768",
        padding: "10px", borderRadius: "5px", position: "relative" }
      }
    >
      <span
        style={{
          display: "flex", flexDirection: "row", alignItems: "center", gap: "5px", width: "85%"
        }}
      >
        { detailType == "warning" ? 
        <svg width="20px" height="20px" style={{color: "#FFA231"}} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M12 8V12M12 16H12.01M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        : undefined }
        {msg}
      </span>
      <p style={
        detailType == "warning" ?
        {color: "#FFA231", marginBottom: "0px", marginTop: "5px", fontSize: "12px"}
        :
        {color: "#62b768", marginBottom: "0px", marginTop: "5px", fontSize: "12px"}
        }
      >
      {"(Used during the resume generation process)"}
      </p>
      <Link 
        to={navLink}
        style={{
          backgroundColor: "white", padding: "5px", borderRadius: "5px", fontSize: "12px",
          position: "absolute", top: "8px", right: "8px"
        }}
      >Update</Link>
    </article>
  )
}